module.exports = __webpack_public_path__ + "img/tablet-elbow-1_90x118.5cfe8183.png";